import PropTypes from 'prop-types'
import React from 'react'
import { getStatusIconName } from 'utils/status'
import {
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'
import KanBoIcon from 'components/KanBoIcon'
import classes from './Point.module.scss'

export class Line extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    role: PropTypes.number.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onClick: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick (event) {
    if (this.props.onClick) this.props.onClick(event)
  }

  render () {
    const {
      name,
      role,
      isSelected,
      onClick,
      ...props
    } = this.props

    let compClassName = classes.point
    if (isSelected) compClassName += ' ' + classes.selected
    if (onClick) compClassName += ' ' + classes.selectable

    return (
      <OverlayTrigger
        placement='top'
        animation={false}
        overlay={
          <Tooltip>{name}</Tooltip>
        }
      >
        <KanBoIcon
          {...props}
          fixedWidth
          name={getStatusIconName(role)}
          className={compClassName}
          onClick={this.handleClick}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        />
      </OverlayTrigger>
    )
  }
}

export default Line
